"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var text_width = require("text-width");

function computeLabelWidth(sequence_data, padding) {
  var label_width = sequence_data.map(function (record) {
    return text_width(record.header, {
      family: "Courier",
      size: 14
    });
  }).reduce(function (a, b) {
    return Math.max(a, b);
  }, 0);
  return padding + label_width;
}

var _default = computeLabelWidth;
exports["default"] = _default;